export default __webpack_public_path__ + "static/media/producto-26.753d82d7.jpeg";